module.exports = __webpack_public_path__ + "static/[edgeinnovationcenter.com][718]5-2-97751d925b637951c47bdcbcf3c1ea9d.jpg";